import styles from "./styles.module.scss";
import React, { FunctionComponent } from "react";
import { Box, Card, CardActionArea, Stack } from "@mui/material";
import { IExchangeRate } from "../../../../hooks/exchangeRates";
import { format } from "date-fns";
import { strings } from "../../../../localization/LocalizedStrings";
import { useCurrencyFormatter } from "../../../../hooks/currencyFormatter";
import { useUserProfile } from "../../../../hooks/session";
import { Icon, IconType } from "../../../../icons";

export const ExchangeRateCard: FunctionComponent<IExchangeRateCardProps> = ({
  exchangeRate,
  onClick,
  onContextMenu
}) => {
  const currencyFormatter = useCurrencyFormatter();
  const [currentUserProfile] = useUserProfile.useState();
  const getDate = () => {
    const date = new Date(exchangeRate.unixTimestamp * 1000);
    return format(date, "d MMM yyyy", { locale: strings.fnsLocale });
  };
  return (
    <Card sx={{ height: 70, borderRadius: "20px" }} elevation={5}>
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row"
        }}
        onClick={onClick}
        onContextMenu={onContextMenu}
      >
        <Stack alignItems={"center"}>
          <Card className={styles.defaultIcon}>
            <Icon type={IconType.CurrencyExchange} />
          </Card>
        </Stack>
        <Stack className={styles.rightContainer} spacing={1}>
          <Stack direction="row">
            <Box flexGrow={1} />
            <Card className={styles.rateCard}>
              <p className={styles.rate}>
                {currencyFormatter.format(exchangeRate.rate, currentUserProfile, false, 2)}
              </p>
            </Card>
            <Box flexGrow={1} />
          </Stack>
          <p className={styles.date}>{getDate()}</p>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export interface IExchangeRateCardProps {
  exchangeRate: IExchangeRate;
  onClick: () => void;
  onContextMenu: (event: React.MouseEvent) => void;
}
